import axios from 'axios';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { baseUrl_, timeout } from '../utils/constants';
import customToast, { ToastType } from '../components_/Toast';
import { decryptJson } from '../utils/decryptJson';
import { Request } from '../apis/request';

type TParams = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onGetTokenSuccess?: () => void;
  onGetTokenFailure?: () => void;
};

export const useGetToken = ({
  onGetTokenSuccess = () => {
    return;
  },
  onGetTokenFailure = () => {
    customToast('An error occured while getting the otp', ToastType.error);
  },
}: TParams) => {
  const [loading, setLoading] = useState(false);
  const [otpType, setOtpType] = useState('sms');
  const loginToken = localStorage.getItem('login-token');
  const getTokenApi = (token: string | null) => {
    setLoading(true);
    const tokenToUse = loginToken ? loginToken : token;
    Request.get(`/verify/phone-number`, {
      headers: {
        Authorization: `Bearer ${tokenToUse}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      timeout: timeout,
    })
      .then((res) => {
        res.data.status === 200 && onGetTokenSuccess();
        const data = decryptJson(res?.data?.data);
        setOtpType(data?.type);
        setLoading(false);
      })
      .catch(() => {
        onGetTokenFailure();
        setLoading(false);
      });
  };

  return { getTokenApi, loading, otpType };
};
